
import { Injectable } from '@angular/core'
import { BehaviorSubject, timer } from 'rxjs'
import {TestbedRxdbCollectionService} from './testbed-rxdb-collection.service'

@Injectable({
    providedIn: 'root',
})
export class TestbedRxdbState {

    // Track a global error retry time to reduce network requests when couchdb not reachable
    // If one collection fails, other collections will wait a little longer.
    nextRetryTimeMs : number = null

    bAllOk = false
    bSynced = false
    bActiveSync = false
    httpRespWarningMsg : string = ""
    
    readySubject = new BehaviorSubject<boolean>(null)

    isReady = () => this.readySubject.value
    
    collectionServices : TestbedRxdbCollectionService<any,any>[] = []

    getOkCount() : number {
        const services = this.collectionServices //TBD will all services by syncable? .filter(service=>service.syncConfig)
        const isOk = ( code ) => code !== -1 && ( (code >= 200 && code < 300) || code == 404) // couch tests endpoints that return 404
        const okCnt = services.filter(service=>isOk(service.httpStatusCode)).length
        return okCnt
    }


    updateAllOk() : void {
        const okCnt = this.getOkCount()
        this.bAllOk = this.collectionServices.length == okCnt
    }


    someRemoteCollectionsUnauthorized() : boolean {
        return this.collectionServices.some(service=>service.isRemoteCollectionUnauthorized())
    }


    everyRemoteCollectionDown() : boolean {
        return this.collectionServices.every(service =>service.isRemoteCollectionDown())
    }


    nextRetryDelayMs() {
        const nowMs = Date.now()
        const errorIntervalMs = 15000
        let nextErrorTimeMs = nowMs + errorIntervalMs
        if ( this.nextRetryTimeMs ) {
            nextErrorTimeMs = this.nextRetryTimeMs + errorIntervalMs
        }
        this.nextRetryTimeMs = nextErrorTimeMs
        return nextErrorTimeMs - nowMs
    }


    processSyncActive( source: TestbedRxdbCollectionService<any,any>, bActive: boolean ){
        this.updateActiveSyncStatus()
        this.updateSynced()
    }


    processSyncComplete( source: TestbedRxdbCollectionService<any,any>, bComplete: boolean ){
        this.updateSynced()
    }


    updateActiveSyncStatus() {
        const bActive = this.collectionServices.some(service=>service.bActiveSync)
        // try to prevent flashing sync messages (must be syncing for a little bit)
        timer(500).subscribe( ms => {
            this.bActiveSync = bActive && this.collectionServices.some(service=>service.bActiveSync)
            //console.log(this.collectionMeta.filter(meta=>meta.bActiveSync).map(meta=>meta.collection?.name))
        })    
     }


    updateSynced() {
        this.bSynced = this.collectionServices.every(service=>service.rxCollection.synced)
    }

}
